import { ChangeDetectorRef, Component, ViewChild } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { NgbModal, NgbModalRef } from '@ng-bootstrap/ng-bootstrap';
import { StateService } from 'src/app/core/services/state.service';
import { LazyLoadEvent } from 'primeng/api';
import { ToastService } from 'src/app/core/services/toast.service';
import { Table } from 'primeng/table';

@Component({
  selector: 'app-state',
  templateUrl: './state.component.html',
  styleUrl: './state.component.scss'
})
export class StateComponent {
  states: any[] = [];
  stateForm!: FormGroup;
  modalRef!: NgbModalRef;
  loading = false;
  editingPlan: any = null;
  isEditMode = false;
  totalRecords = 0;
  rows = 10;
  searchText = '';
  // rangeDates: Date[] | null = null;
  @ViewChild('dt') table!: Table;

  constructor(
    private stateService: StateService,
    private fb: FormBuilder,
    private modalService: NgbModal,
    private toastService: ToastService,
    private cdr: ChangeDetectorRef
  ) { }

  ngOnInit() {
    this.stateForm = this.fb.group({
      name: ['', [Validators.required]],
      key: ['', [Validators.required]]
    });
  }

  formatDate(date: Date): string {
    const y = date.getFullYear();
    const m = (date.getMonth() + 1).toString().padStart(2, '0');
    const d = date.getDate().toString().padStart(2, '0');
    return `${y}-${m}-${d}`;
  }

  getStates(event: LazyLoadEvent) {
    this.loading = true;
    this.cdr.detectChanges();
    const first = event?.first ?? 0;
    const rows = event?.rows ?? this.rows;
    const page = first / rows + 1;
    let startDate: string | null = null;
    let endDate: string | null = null;

    // if (this.rangeDates && this.rangeDates.length === 2) {
    //   startDate = this.formatDate(this.rangeDates[0]);
    //   endDate = this.formatDate(this.rangeDates[1]);
    // }

    const queryParams = {
      page: page,
      limit: rows,
      search: this.searchText,
      startDate: startDate,
      endDate: endDate
    }

    this.stateService.getStates(queryParams).subscribe({
      next: (res: any) => {
        this.states = res?.data || [];
        this.totalRecords = res?.totalCount || 0;
        this.loading = false;
        this.cdr.detectChanges();
      },
      error: () => {
        this.loading = false;
        this.cdr.detectChanges();
      }
    });
  }

  filterChange(event: any) {
    this.searchText = event.search;
    // this.rangeDates = event.dateRange
    this.table?.reset();
  }

  deleteState(state: any) {
    if (confirm('Are you sure you want to delete this record?')) {
      this.stateService.deleteState(state._id).subscribe(() => {
        this.getStates({ first: 0, rows: this.rows });

      });
    }
  }

  openCreateModal(content: any) {
    this.isEditMode = false;
    this.editingPlan = null;
    this.stateForm.reset();
    this.modalRef = this.modalService.open(content, { size: 'md' });
  }

  openEditModal(state: any, content: any) {
    this.isEditMode = true;
    this.editingPlan = state;
    this.stateForm.patchValue({
      name: state.name,
      key: state.key,
    });
    this.modalRef = this.modalService.open(content, { size: 'md' });
  }

  closeModal() {
    if (this.modalRef) {
      this.modalRef.dismiss();
    }
  }


  submit() {
    if (this.stateForm.invalid) return;

    this.loading = true;

    if (this.editingPlan && this.editingPlan._id) {
      this.stateService
        .updateState(this.editingPlan._id, this.stateForm.value)
        .subscribe({
          next: (res: any) => {
            this.loading = false;
            this.closeModal();
            this.getStates({ first: 0, rows: this.rows });
            this.toastService.showToaster("Updated", res?.message, "success");
          },
          error: () => {
            this.loading = false;
          }
        });

    } else {
      this.stateService
        .createState(this.stateForm.value)
        .subscribe({
          next: (res: any) => {
            this.loading = false;
            this.getStates({ first: 0, rows: this.rows });
            this.closeModal();
            this.toastService.showToaster("Updated", res?.message, "success");
          },
          error: () => {
            this.loading = false;
          }
        });
    }
  }
}
